export default __webpack_public_path__ + "static/media/info.07559470.svg";